<template>
  <section  id="services">
    <div>
      <!-- Left Section -->
      <div class="row">
        <div class="col-md-6 red-section">
          <div class="feature-card" v-for="(feature, index) in features" :key="index">
            <div class="icon-container">
              <img :src="feature.icon" alt="Feature Icon" class="icon">
            </div>
            <div class="feature-content">
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.description }}</p>
            </div>
          </div>
        </div>
        <!-- Right Section -->
        <div class="col-md-6 white-section">
          <img src="@/assets/images/feature_section/application.png"  style="width: 100vh; margin-left: -25vh;" >
          <!-- <div class="white-content">
            <h1 class="highlighted-title">EvacTracker is here to disrupt for good.</h1>
            <h3>Core benefits of EvacTracker</h3>
            <ul class="points">
              <li>Save Lives – <strong>seamless connectivity</strong> with all facing an emergency.</li>
              <li>Save Time – <strong>Live information feed</strong> from all including the portal.</li>
              <li>Save Money – A proactive approach to <strong>emergency response management.</strong></li>
              <li>Improve Continuously – Performance <strong>appraisal</strong> and <strong>training.</strong></li>
              <li>Easy Adaptability – <strong>Independent</strong> of any special hardware deployment.</li>
            </ul>
            <h4><b>Positive Ratings</b></h4>
            <b-progress :max="max" height="2rem">
              <b-progress-bar variant="danger" striped="striped" :value="value">
                <span style="color: black; font-size: 14px;"><strong>{{ value }} %</strong></span>
              </b-progress-bar>
            </b-progress>
          </div> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturesSection',
  data() {
    return {
      features: [
        { 
          title: 'Emergency Response Management Consulting', 
          description: 'The cumulative team experience of EvacTracker is over 200 years offering risk management, audit, consulting, procurement, policy and framework restructuring along with training.',
          icon: require('@/assets/images/feature_section/hr-icon-01.png') // Replace with the actual path to your icon
        },
        { 
          title: 'EvacTracker Mobile Application', 
          description: 'For the first time ever, EvacTracker has built a mobile application which seamlessly connects Chief Warden, Floor Wardens, Wardens, and External Response Teams. It gives live information feed with predefined processes to follow.',
          icon: require('@/assets/images/feature_section/hr-icon-02.png') 
        },
        { 
          title: 'EvacTracker Online Portal', 
          description: 'The backbone of EvacTracker is its powerful online portal where ECL, site maps, and a lot of information is stored which can be easily pulled out during or post emergency.',
          icon: require('@/assets/images/feature_section/hr-icon-03.png' )
        }
      ],
      value: 95,
      max: 100
    };
  }
};
</script>

<style scoped>
.features-section {
  padding: 0 0;
  background-color: #febc03;
  height: 100vh;

}

.red-section {
  background-color: #000000;
  padding: 15vh;
  height: 75vh;
}

.feature-card {
  display: flex;
  margin-bottom: 20px;
  color: #fff;
}

.icon-container {
  margin-right: 15px;
}

.icon {
  width: 60px;
  height: 60px;
}

.feature-content h3 {
  font-size: 3.5vh;
  margin-bottom: 10px;
  color: white;
}

.feature-content p {
  font-size: 1.5vh;
  margin-bottom: 10px;
}



.white-section {
  background-color: #fff;
  padding: 50px;
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center;    /* Center vertically */
  height: 75vh;
}

.white-content h2 {
  font-size: 2rem;
  color: #003e9b;
  margin-bottom: 20px;
}


.white-content h3 {
  font-size: 2rem;
  margin-bottom: 15px;
  font-family: 'Roboto', sans-serif;
  font-weight: bolder;
  color: rgb(58, 56, 56);
}

.white-content ul {
  padding: 30px !important;
}

.white-content ul li {
  font-size: 1.2rem;
  margin-bottom: 10px;
  color: black;
  font-weight: 500;
}
.highlighted-title
{
  font-size: 3rem;
  font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  font-weight: bolder;
  color: black;
}






</style>
